module.exports = __webpack_public_path__ + "img/craft_2.33e3a326.jpg";